module.exports = __webpack_public_path__ + "static/img/table@2x.6c27b3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/ktb/table@2x.png
// module id = ANLi
// module chunks = 69